// extracted by mini-css-extract-plugin
export default {"container":"SettingsPage_container__rTGCU","loading":"SettingsPage_loading__i-hM2","spin":"SettingsPage_spin__8UnMB","content":"SettingsPage_content__ImODC"};